export const NIGHT_SHIFT_LIMITATION_SYSTEM = {
  SHIFTS_PER_16_WEEKS: '43_SHIFTS_PER_16_WEEKS',
  HOURS_PER_2_WEEKS: '20_HOURS_PER_2_WEEKS',
} as const;

export type NightShiftLimitationSystem =
  (typeof NIGHT_SHIFT_LIMITATION_SYSTEM)[keyof typeof NIGHT_SHIFT_LIMITATION_SYSTEM];

export type RestRulesFormContext = {
  shouldAdhereToDrivingRestRules?: boolean;
  nightShiftLimitationSystem?: NightShiftLimitationSystem;
};
